import { render, staticRenderFns } from "./paginacion.vue?vue&type=template&id=b8d3fab2&"
import script from "./paginacion.vue?vue&type=script&lang=js&"
export * from "./paginacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports